import { DEFAULT_LOCALE } from "./localization.constants";
import { useLocale } from "./use-locale";

export function isLocalizableHref(href: string) {
    // only paths starting with a single slash to prevent localizing URLs
    return /^\/[^\/]/.test(href);
}

export function useLocalizedHref(href: string) {
    const locale = useLocale();
    if (locale === DEFAULT_LOCALE) {
        return href;
    } else {
        return `/${locale}${href}`;
    }
}
